/* global route, install */

const RoutePlugin = {
  install(Vue, options = {}) {
    Vue.prototype.$route = (...args) => {
      const [name, parameters, absolute] = args;

      return route(name, parameters, absolute === true);
    };

    Vue.prototype.$isCurrentRoute = (name) => route().current(name);

    Vue.prototype.$currentRoute = () => route().current();
  },
};

export default RoutePlugin;
